import type { SVGProps } from 'react'
const SvgReject = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.0005 8.05376L1.9275 13.127C1.789 13.2653 1.61492 13.3362 1.40525 13.3395C1.19575 13.3427 1.0185 13.2718 0.8735 13.127C0.728667 12.982 0.65625 12.8063 0.65625 12.6C0.65625 12.3937 0.728667 12.218 0.8735 12.073L5.94675 7.00001L0.8735 1.92701C0.735167 1.78851 0.664333 1.61443 0.661 1.40476C0.657833 1.19526 0.728667 1.01801 0.8735 0.873012C1.0185 0.728178 1.19417 0.655762 1.4005 0.655762C1.60683 0.655762 1.7825 0.728178 1.9275 0.873012L7.0005 5.94626L12.0735 0.873012C12.212 0.734678 12.3861 0.663845 12.5958 0.660512C12.8053 0.657345 12.9825 0.728178 13.1275 0.873012C13.2723 1.01801 13.3448 1.19368 13.3448 1.40001C13.3448 1.60635 13.2723 1.78201 13.1275 1.92701L8.05425 7.00001L13.1275 12.073C13.2658 12.2115 13.3367 12.3856 13.34 12.5953C13.3432 12.8048 13.2723 12.982 13.1275 13.127C12.9825 13.2718 12.8068 13.3443 12.6005 13.3443C12.3942 13.3443 12.2185 13.2718 12.0735 13.127L7.0005 8.05376Z"
      fill="#757575"
    />
  </svg>
)

export default SvgReject
